import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// A lazy page chunk failed to load (e.g. a new deploy replaced it): reload instead of a blank page
window.addEventListener("vite:preloadError", () => window.location.reload());

createRoot(document.getElementById("root")!).render(<App />);
